import React from 'react';
import Typography from '@mui/material/Typography';
import { getLanguage } from 'translation';
import { styled } from '@mui/system';
import CoastsIcon from 'assets/icons/coasts.svg?react';
import LocationIcon from 'assets/icons/location_c.svg?react';
import ExperienceIcon from 'assets/icons/experience.svg?react';
import getYearsLabel from 'helpers/getYearsLabel';

const Title = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  color: theme.palette.textPrimary.main,
  marginBottom: '20px',
  ...theme.textCut('2'),
  [theme.breakpoints.down('md')]: {
    fontSize: 24,
    lineHeight: '28px'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 18,
    lineHeight: '18px'
  }
}));

const TemplateText = styled(Typography)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  color: theme.palette.textPrimary.main,
  marginBottom: 10,
  '&:last-child': {
    marginBottom: 0
  },
  '& svg': {
    marginRight: 10,
    flex: 1
  },
  '& span': {
    flex: 5,
    ...theme.textCut(2)
  }
}));

const CardTemplate = ({ t, item }) => {
  const [lang] = React.useState(getLanguage().toUpperCase());

  const title = React.useMemo(
    () => `${item[`firstName${lang}`]} ${item[`lastName${lang}`]}`,
    [lang, item]
  );

  const minPrice = React.useMemo(
    () => Math.min(...(item?.services || []).map(({ price }) => price)),
    [item]
  );

  return (
    <>
      <Title variant="h3">{title}</Title>

      <TemplateText>
        <ExperienceIcon />
        <span>
          {t('YearsExp', { count: `${item?.experience} ${t(getYearsLabel(item?.experience))}` })}
        </span>
      </TemplateText>

      <TemplateText>
        <CoastsIcon />
        <span>
          {t('From')}{' '}
          <b>
            {minPrice} {t('Currency')}
          </b>
          {' / '}
          {t('PerSession')}
        </span>
      </TemplateText>

      <TemplateText>
        <LocationIcon />
        <span>
          {item?.isWorkOffline ? (
            <>
              {item?.location}
              {t('Or')}
            </>
          ) : null}
          {t('Online')}
        </span>
      </TemplateText>
    </>
  );
};

export default CardTemplate;
